import FormModal from "../../../components/FormModal/FormModal";
import TextInput from "../../../components/TextInput/TextInput";
import Buttons from "../../../components/Buttons/Buttons";
import FieldLabel from "../../../components/FieldLabel/FieldLabel";
import { UDI_STATIC_PREFIX } from "./useHealthCareDevices";

const DEVICE_NAME_PREFIX = "We-Be ";

const ReadOnlyField = ({ label, value }) => (
  <div className="add-device-readonly-field">
    <FieldLabel>{label}</FieldLabel>
    <div className="add-device-readonly-value">{value || "-"}</div>
  </div>
);

const HealthCareDeviceFormModal = ({
  open,
  onClose,
  isViewMode,
  addForm,
  errors,
  onChange,
  onSubmit,
}) => (
  <FormModal
    open={open}
    onClose={onClose}
    title={isViewMode ? "Device Details" : "Add New Device"}
    actions={
      isViewMode ? (
        <Buttons text="Close" variant="secondary" onClick={onClose} />
      ) : (
        <>
          <Buttons text="Cancel" variant="secondary" onClick={onClose} />
          <Buttons text="Submit" variant="primary" onClick={onSubmit} />
        </>
      )
    }
  >
    <div className="add-device-form-container">
      <div className="add-device-form-field">
        {isViewMode ? (
          <ReadOnlyField label="Device Name" value={addForm.deviceName} />
        ) : (
          <>
            <TextInput
              title="Device Name*"
              type="text"
              name="deviceName"
              value={addForm.deviceName}
              onChange={onChange}
              placeholder="72f9"
              prefixText={DEVICE_NAME_PREFIX}
              maxLength={4}
              error={!!errors.deviceName}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onSubmit();
                }
              }}
            />
            {errors.deviceName && <span className="error">{errors.deviceName}</span>}
          </>
        )}
      </div>

      {isViewMode ? (
        <div className="add-device-form-field">
          <ReadOnlyField
            label="Device UDI"
            value={
              addForm.udiLotCode && addForm.udiSerial
                ? `${UDI_STATIC_PREFIX}(10)${addForm.udiLotCode}(21)${addForm.udiSerial}`
                : ""
            }
          />
        </div>
      ) : (
        <div className="add-device-form-field add-device-udi-section">
          <div className="add-device-udi-header">
            <FieldLabel>Device UDI</FieldLabel>
            <span className="add-device-udi-prefix">
              Prefix: <strong>{UDI_STATIC_PREFIX}</strong>
            </span>
          </div>
          <div className="add-device-udi-inputs">
            <TextInput
              name="udiLotCode"
              placeholder="e.g., 00A"
              prefixText="(10)"
              maxLength={3}
              value={addForm.udiLotCode}
              onChange={onChange}
              error={!!errors.udiLotCode}
              helperText={errors.udiLotCode}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onSubmit();
                }
              }}
            />
            <TextInput
              name="udiSerial"
              placeholder="e.g., 0000000"
              prefixText="(21)"
              maxLength={7}
              value={addForm.udiSerial}
              onChange={onChange}
              error={!!errors.udiSerial}
              helperText={errors.udiSerial}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onSubmit();
                }
              }}
            />
          </div>
        </div>
      )}

      {isViewMode && (
        <div className="add-device-form-field">
          <ReadOnlyField label="Number Of Slots" value={addForm.numberOfSlots} />
        </div>
      )}
    </div>
  </FormModal>
);

export default HealthCareDeviceFormModal;
